import { render, staticRenderFns } from "./bankruptcyManagerCheck.vue?vue&type=template&id=9a4a43e0&scoped=true&"
import script from "./bankruptcyManagerCheck.vue?vue&type=script&lang=js&"
export * from "./bankruptcyManagerCheck.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcyManagerCheck.vue?vue&type=style&index=0&id=9a4a43e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4a43e0",
  null
  
)

export default component.exports